// ============================================================
//  CFO Bridge UAE — Shared helpers for blogs & case studies
//  These no longer import a static data array. Every function
//  takes the array (from DataContext) as its first argument.
// ============================================================

export const CATEGORIES = [
  "All",
  "VAT & Tax",
  "Financial Planning",
  "Business Strategy",
  "Fundraising",
  "Corporate Governance",
  "UAE Finance",
];

export const INDUSTRIES = [
  "All",
  "Retail / E-commerce",
  "Manufacturing",
  "Real Estate",
  "Healthcare",
  "Technology / SaaS",
  "Hospitality",
  "Logistics",
  "Professional Services",
];

export function getBlogBySlug(blogs, slug) {
  return blogs.find((b) => b.id === slug) || null;
}

export function getRelatedBlogs(blogs, currentSlug, count = 3) {
  const current = getBlogBySlug(blogs, currentSlug);
  if (!current) return [];
  return blogs
    .filter((b) => b.id !== currentSlug)
    .sort((a, b) => {
      const aMatch = a.category === current.category ? 1 : 0;
      const bMatch = b.category === current.category ? 1 : 0;
      return bMatch - aMatch;
    })
    .slice(0, count);
}

export function getCaseStudyBySlug(caseStudies, slug) {
  return caseStudies.find((c) => c.id === slug) || null;
}

export function getRelatedCaseStudies(caseStudies, currentSlug, count = 3) {
  const current = getCaseStudyBySlug(caseStudies, currentSlug);
  if (!current) return [];
  return caseStudies
    .filter((c) => c.id !== currentSlug)
    .sort((a, b) => {
      const aMatch = a.industry === current.industry ? 1 : 0;
      const bMatch = b.industry === current.industry ? 1 : 0;
      return bMatch - aMatch;
    })
    .slice(0, count);
}

export function formatDate(dateStr) {
  return new Date(dateStr).toLocaleDateString("en-AE", {
    day: "numeric",
    month: "long",
    year: "numeric",
  });
}